module.exports = __webpack_public_path__ + "static/ForTheOffice-intro-6b726e7560b78b329c2ae5f812d7cca2.jpg";